const paragraphSchema = {
	group: "block",
	content: "inline*",
};

export default paragraphSchema;
